<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 673.12 673.12" style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:25.12px;"><rect class="cls-1" x="12.56" y="12.56" width="648" height="648" rx="77.08"/><rect class="cls-1" x="375.04" y="185.35" width="195.17" height="142.06"/><rect class="cls-1" x="102.91" y="185.35" width="195.17" height="142.06"/><rect class="cls-1" x="236.73" y="392.72" width="195.17" height="142.06"/></svg>
</template>

<script>
export default {}
</script>
